import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { colors } from 'parameters/ui'
import { Modifiable, Mods } from 'components/styles/primitives/core/mods'

export const baseCSS = css`
	appearance: none;
	-webkit-appearance: none;
	padding: 11px 16px;
	outline: none;
	border: 1px solid ${colors.secondaryLightGrey1};
	color: ${colors.black};
	border-radius: 4px;
	display: block;
	width: 100%;
	font-size: 16px;
	background: ${colors.white};
	font-weight: 400;
	height: 48px;
	transition: 0.5s;
	box-shadow: none;

	&:disabled {
		border: 1px solid ${colors.secondaryLightGrey1};
		background: ${colors.primaryLightGrey1};
	}

	&:hover:not(:focus) {
		border: 1px solid ${colors.secondaryDarkGrey1};
	}

	&:focus {
		border: 1px solid ${colors.secondaryPurple1};
	}

	/* Chrome, Safari, Edge, Opera */

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */

	&[type='number'] {
		-moz-appearance: textfield;
	}
`

const hasErrorCSS = css`
	/* Overwrite hover styles */
	border: 1px solid ${colors.errorRed1} !important;
`

export const InputBox = styled.div`
	position: relative;
`

export const InputIconBox = styled.div`
	height: calc(100% - 4px);
	width: 40px;
	position: absolute;
	right: 2px;
	top: 2px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background: ${colors.white};
`

export interface StyledInputProps {
	error?: boolean | string // Hack
}

export const error = ({ error = undefined }: StyledInputProps) => error && hasErrorCSS

export const CustomInput = styled.input<StyledInputProps & Mods>`
	${baseCSS}
	${error}
  ${Modifiable};
`
